// Frogfoot packages
export const frogfootPackages = [
  {
    ID: 2802752,
    Title: "Frogfoot FTTH 1000/500Mbps - FF by Wondernet",
    Price: 1549.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 512000,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 2802754,
    Title: "Frogfoot FTTH 1000/1000Mbps - FF by Wondernet",
    Price: 1599.00,
    "Download speed (kbps)": 1024000,
    "Upload speed (kbps)": 1024000,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662475,
    Title: "Frogfoot FTTH 60/30Mbps - FF by Wondernet",
    Price: 699.00,
    "Download speed (kbps)": 61440,
    "Upload speed (kbps)": 30720,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662631,
    Title: "Frogfoot FTTH 60/60Mbps - FF by Wondernet",
    Price: 799.00,
    "Download speed (kbps)": 61440,
    "Upload speed (kbps)": 61440,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662806,
    Title: "Frogfoot FTTH 120/60Mbps - FF by Wondernet",
    Price: 829.00,
    "Download speed (kbps)": 122880,
    "Upload speed (kbps)": 61440,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662823,
    Title: "Frogfoot FTTH 120/120Mbps - FF by Wondernet",
    Price: 899.00,
    "Download speed (kbps)": 122880,
    "Upload speed (kbps)": 122880,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662837,
    Title: "Frogfoot FTTH 240/120Mbps - FF by Wondernet",
    Price: 979.00,
    "Download speed (kbps)": 245760,
    "Upload speed (kbps)": 122880,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662885,
    Title: "Frogfoot FTTH 240/240Mbps - FF by Wondernet",
    Price: 1199.00,
    "Download speed (kbps)": 245760,
    "Upload speed (kbps)": 245760,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21662939,
    Title: "Frogfoot FTTH 400/400Mbps - FF by Wondernet",
    Price: 1399.00,
    "Download speed (kbps)": 409600,
    "Upload speed (kbps)": 409600,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  },
  {
    ID: 21663051,
    Title: "Frogfoot FTTH 400/200Mbps - FF by Wondernet",
    Price: 1299.00,
    "Download speed (kbps)": 409600,
    "Upload speed (kbps)": 204800,
    Supplier: "Frogfoot",
    ISP: "Wondernet"
  }
];